module.exports = __webpack_public_path__ + "../resources/img/ic_re_wind_solid.324b716d.svg";